import React from 'react';
import { SectionOutro } from '../../../../openapi/atlantis';
import { ConfigDrivenOutroTemplate, EnumMap } from '../../../../types';
import { ApplicationStepWithNewContent } from '../../../../utils/ConfigDrivenFormUtils';
import { safeEnumMapGet } from '../../../../utils/EnumHelper';
import ConfigDrivenOnboardingOutroContainer from '../ConfigDrivenOnboardingOutroContainer';
import ConfigDrivenOnboardingOutroContainerV2 from '../ConfigDrivenOnboardingOutroContainerV2';

interface ConfigDrivenOutroWrapperProps {
  config: ApplicationStepWithNewContent<SectionOutro>;
}

interface ConfigDrivenOutroTemplateProps {
  config: ApplicationStepWithNewContent<SectionOutro>;
}

const ConfigDrivenOutroWrapper: React.FC<ConfigDrivenOutroWrapperProps> = ({
  config,
}) => {
  const CONFIG_DRIVEN_OUTRO_CONTAINER: EnumMap<
    ConfigDrivenOutroTemplate,
    React.FC<ConfigDrivenOutroTemplateProps>
  > = {
    [ConfigDrivenOutroTemplate.TEMPLATE_1]:
      ConfigDrivenOnboardingOutroContainer,
    [ConfigDrivenOutroTemplate.TEMPLATE_2]:
      ConfigDrivenOnboardingOutroContainerV2,
    [ConfigDrivenOutroTemplate.TEMPLATE_3]:
      ConfigDrivenOnboardingOutroContainerV2,
  };

  const ConfigDrivenOutroComponent = safeEnumMapGet(
    CONFIG_DRIVEN_OUTRO_CONTAINER,
    config?.content?.style?.template as unknown as ConfigDrivenOutroTemplate,
    CONFIG_DRIVEN_OUTRO_CONTAINER[ConfigDrivenOutroTemplate.TEMPLATE_1],
  );

  return <ConfigDrivenOutroComponent config={config} />;
};

export default ConfigDrivenOutroWrapper;
